import { render, staticRenderFns } from "./ProgramPage.vue?vue&type=template&id=1e1151c5&scoped=true&"
import script from "./ProgramPage.vue?vue&type=script&lang=ts&"
export * from "./ProgramPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramPage.vue?vue&type=style&index=0&id=1e1151c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1151c5",
  null
  
)

export default component.exports